// components
import { RForm } from '@/components/reusable_components/next'
import { beforeRouteEnter } from '@/mixins/reusable_mixins/permissions'
import translatorService from '@/services/translator'

// models
import DispatchRequestService from '@/services/api/Warehouse/WhDispatchRequest'
import DispatchRequestModel from '@/models/Warehouse/WhDispatchRequest'
import DispatchRequestFields from '@/views/Warehouse/WhDispatchRequest/update/fields'

// view
export default {
    name: 'dispatch-requests-update',
    components: {
        RForm,
    },
    computed: {

        /**
         * 
         */
        confirmProps() {
          return {
            fields: [
              {
                name: 'auth_code',
                type: 'password-field',
                flex: {
                  xs12: true,
                },
                props: {
                  label: 'Código del que confirma'
                },
              },
              {
                name: 'comment',
                type: 'textarea',
                flex: {
                  xs12: true,
                },
                props: {
                  label: 'Cómentario de rectificación',
                  placeholder: 'Rellenar solo para rectificación',
                },
              },
            ]
          }
        },
        /**
         * 
         */
        invoiceProps() {
            return {
                fields: [
                    {
                        name: 'invoice_comment',
                        type: 'textarea',
                        flex: {
                            xs12: true,
                        },
                        props: {
                            label: 'Comentario de factura',
                        },
                    }
                ]
            }
        },    
        /**
         * 
         */
        revisionProps() {
          return {
            fields: [
              {
                name: 'package_number',
                type: 'float-field',
                flex: {
                  sm6: true,
                  xs12: true,
                },
                props: {
                  label: 'Número de Bultos'
                },
              },
              {
                name: 'package_cube',
                type: 'text-field',
                flex: {
                  sm6: true,
                  xs12: true,
                },
                props: {
                  label: 'Cubo '
                },
              },
              {
                name: 'auth_code',
                type: 'password-field',
                flex: {
                  xs12: true,
                },
                props: {
                  label: 'Código del que arma'
                },
              },
            ]
          }
        },

        /**
         * Determines if editable.
         *
         * @return     {boolean}  True if editable, False otherwise.
         */
        isEditable() {
            return (
                (this.formData.can_confirm || this.formData.can_revision || this.formData.can_edit) &&
                this.$can('EDIT_DISPATCH_REQUEST')
            )
        },

        /**
         * { function_description }
         *
         * @return     {Object}  { description_of_the_return_value }
         */
        fieldsProps() {
            return {
                g_branch_office_id: 1,
                readonly: !this.formData.can_edit,
            }
        },

        /**
         * { function_description }
         *
         * @return     {Object}  { description_of_the_return_value }
         */
        formProps() {
            return {
                editable: this.isEditable,
                fields: DispatchRequestFields(this.fieldsProps),
                loading: this.formLoading,
                noSubmit: this.formData.can_confirm,
                switchEdit: this.isEditable,
                title: this.title,
            }
        },

        /**
         *
         */
        title() {
            let title = `Solicitud de despacho #${this.$route.params.id}`
            if (this.storePickup) title += ' - PARA RETIRO EN TIENDA'
            return title
        },
    },
    data() {
        return {
            busy: false,
            formData: {},
            formLoading: false,
            storePickup: false,
            dialogs: {
                confirm: false,
                invoice: false,
                revision: false,
            },
        }
    },
    methods: {
        /**
         * Fetches a form data.
         *
         * @return     {<type>}  The form data.
         */
        fetchFormData() {
            return DispatchRequestModel.modeler()
                .find(this.$route.params.id)
                .then(dr => {
                    if (
                        dr.sale_comment.includes(
                            'COMENTARIO DEL SISTEMA: RETIRO EN TIENDA'
                        )
                    ) {
                        this.storePickup = true
                    }
                    this.setFormData(dr)
                })
        },

    /**
     * { function_description }
     */
    redirect() {
      this.$router.push({ 
        name: this.$route.query.from || 'dispatch-request-list' 
      })
    },

        /**
         * Resets the object.
         */
        reset() {
            this.setFormLoading(true)
                .then(this.fetchFormData)
                .then(this.setFormLoading)
        },

        /**
         * Sets the form data.
         *
         * @param      {<type>}   model   The model
         * @return     {Promise}  { description_of_the_return_value }
         */
        async setFormData(model) {
            this.formData = model.reset()
        },

        /**
         * Sets the form loading.
         *
         * @param      {boolean}  [value=false]  The value
         */
        async setFormLoading(value = false) {
            this.formLoading = value
        },

        /**
         * Shows the success arm.
         */
        showSuccessArm() {
            this.showSuccessSnackbar(
                'Solicitud de despacho establecida en armando.'
            )
        },
        /**
         * Shows the success confirm.
         */
        showSuccessConfirm() {
            this.showSuccessSnackbar('Solicitud de despacho confirmada.')
        },
        /**
         * Shows the success confirm.
         */
        showSuccessUpdateInvoice() {
            this.showSuccessSnackbar('Comentario de factura actualizado.')
            this.dialogs.invoice = false
        },
        /**
         * Shows the success not reception.
         */
        showSuccessNotReception() {
            this.showSuccessSnackbar('Solicitud de despacho no recepcionada.')
        },

        /**
         * Shows the success partial reception.
         */
        showSuccessPartialReception() {
            this.showSuccessSnackbar(
                'Solicitud de despacho parcialmente recepcionada.'
            )
        },

        /**
         * Shows the success reception.
         */
        showSuccessReception() {
            this.showSuccessSnackbar('Solicitud de despacho recepcionada.')
        },

        /**
         * Shows the success reception.
         */
        showSuccessRectify() {
            this.showSuccessSnackbar('Solicitud de despacho rectificada.')
            this.dialogs.confirm = false
        },

        /**
         * Shows the success reception.
         */
        showSuccessRevision() {
            this.showSuccessSnackbar('Solicitud de despacho establecida en revision.')
            this.dialogs.revision = false
        },

        /**
         * Shows the success update.
         */
        showSuccessUpdate() {
            this.showSuccessSnackbar('Solicitud de despacho actualizada.')
        },

        /**
         * { function_description }
         *
         * @return     {<type>}  { description_of_the_return_value }
         */
        submitArm() {
            return this.toWait(true)
                .then(this.toUpdate)
                .then(this.toArm)
                .then(this.showSuccessArm)
                .then(this.redirect)
                .catch(this.toError)
                .then(this.toWait)
        },

        /**
         * { function_description }
         *
         * @return     {<type>}  { description_of_the_return_value }
         */
        submitConfirm() {
            return this.toWaitConfirm(true)
                .then(this.toConfirm)
                .then(this.showSuccessConfirm)
                .then(this.redirect)
                .catch(this.toError)
                .then(this.toWaitConfirm)
        },

        /**
         * { function_description }
         *
         * @return     {<type>}  { description_of_the_return_value }
         */
        submitInvoice() {
            return this.toWaitInvoice(true)
                .then(this.toUpdateInvoice)
                .then(this.showSuccessUpdateInvoice)
                .then(this.reset)
                .catch(this.toError)
                .then(this.toWaitInvoice)
        },

        /**
         * { function_description }
         *
         * @return     {<type>}  { description_of_the_return_value }
         */
        submitNotReception() {
            return this.toWait(true)
                .then(this.toNotReception)
                .then(this.showSuccessNotReception)
                .catch(this.toError)
                .then(this.toWait)
        },

        /**
         * { function_description }
         *
         * @return     {<type>}  { description_of_the_return_value }
         */
        submitPartialReception() {
            return this.toWait(true)
                .then(this.toPartiallyReception)
                .then(this.showSuccessPartiallyReception)
                .catch(this.toError)
                .then(this.toWait)
        },

        /**
         * { function_description }
         *
         * @return     {<type>}  { description_of_the_return_value }
         */
        submitReception() {
            return this.toWait(true)
                .then(this.toReception)
                .then(this.showSuccessReception)
                .catch(this.toError)
                .then(this.toWait)
        },

        /**
         * { function_description }
         *
         * @return     {<type>}  { description_of_the_return_value }
         */
        submitRectify() {
            return this.toWaitConfirm(true)
                .then(this.toRectify)
                .then(this.showSuccessRectify)
                .then(this.reset)
                .catch(this.toError)
                .then(this.toWaitConfirm)
        },

        /**
         * { function_description }
         *
         * @return     {<type>}  { description_of_the_return_value }
         */
        submitRevision() {
            return this.toWaitRevision(true)
                .then(this.toRevision)
                .then(this.showSuccessRevision)
                .then(this.reset)
                .catch(this.toError)
                .then(this.toWaitRevision)
        },

        /**
         * { function_description }
         *
         * @return     {<type>}  { description_of_the_return_value }
         */
        submitUpdate() {
            return this.toWait(true)
                .then(this.toUpdate)
                //.then(this.toUpdateInvoiceComment)
                .then(this.showSuccessUpdate)
                .catch(this.toError)
                .then(this.toWait)
        },

        /**
         * Returns an arm representation of the object.
         *
         * @return     {<type>}  Arm representation of the object.
         */
        toArm() {
            return this.formData.inArmed().sync()
        },

        /**
         * Returns a confirm representation of the object.
         *
         * @return     {<type>}  Confirm representation of the object.
         */
        toConfirm(data) {
            return this.formData.confirm().sync(data)
        },

        /**
         * Catch a error of a dispatch request promise.
         *
         * @param      {Object}  [error={}]  The error.
         * @return     {Promise} The resolve promise of error.
         */
        toError(error = {}) {
            this.showErrorSnackbar(translatorService(DispatchRequestModel,error.response.data))
        },

        /**
         * Returns not reception representation of the object.
         *
         * @return     {<type>}  Not reception representation of the object.
         */
        toNotReception() {
            return this.formData.notReception().sync()
        },

        /**
         * Returns a partially reception representation of the object.
         *
         * @return     {<type>}  Partially reception representation of the object.
         */
        toPartiallyReception() {
            return this.formData.partialReception().sync()
        },

        /**
         * Returns a reception representation of the object.
         *
         * @return     {<type>}  Reception representation of the object.
         */
        toReception() {
            return this.formData.reception().sync()
        },

        /**
         * Returns a reception representation of the object.
         *
         * @return     {<type>}  Reception representation of the object.
         */
        toRectify(data) {
            return this.formData.inRevisionToArmed().sync(data)
        },

        /**
         * Returns a reception representation of the object.
         *
         * @return     {<type>}  Reception representation of the object.
         */
        toRevision(data) {
            return this.formData.inArmedToRevision().sync(data)
        },
        /**
         * Returns an update representation of the object.
         *
         * @return     {<type>}  Update representation of the object.
         */
        toUpdate() {
            return this.formData
                .clone()
                .toUpdate()
                .save()
        },
        /**
         * Returns an update representation of the object.
         *
         * @return     {<type>}  Update representation of the object.
         */
        toUpdateInvoice(data) {
            return this
                .formData
                .invoiceComment()
                .sync(data)
        },
        /**
         * { function_description }
         *
         * @param      {boolean}  [value=false]  The value
         * @return     {<type>}   { description_of_the_return_value }
         */
        toWait(value = false) {
            return this.$refs.form.setWait(value)
        },
        /**
         * { function_description }
         *
         * @param      {boolean}  [value=false]  The value
         * @return     {<type>}   { description_of_the_return_value }
         */
        toWaitConfirm(value = false) {
            return this.$refs.confirm.setWait(value)
        },
        /**
         * { function_description }
         *
         * @param      {boolean}  [value=false]  The value
         * @return     {<type>}   { description_of_the_return_value }
         */
        toWaitInvoice(value = false) {
            return this.$refs.invoice.setWait(value)
        },
        /**
         * { function_description }
         *
         * @param      {boolean}  [value=false]  The value
         * @return     {<type>}   { description_of_the_return_value }
         */
        toWaitRevision(value = false) {
            return this.$refs.revision.setWait(value)
        },
    },
    beforeRouteEnter: beforeRouteEnter('VIEW_DETAIL_DISPATCH_REQUEST'),
    beforeMount() {
        this.setTitle(this.title)
    },
    mounted() {
        this.reset()
    },
}
